import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import DisplayPrice from "components/common/DisplayPrice";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { StatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAddonDetails } from "store/slices/membershipSlice";
import { PLAN_OPTIONS } from "utils/constants";

const AddonDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("membership_addon");
  const { loading, addonDetails } = useSelector((state) => state.Membership);

  useEffect(() => {
    if (id && canView) {
      dispatch(getAddonDetails(id));
    }
  }, [id, canView]);

  const {
    title,
    description,
    status,
    allowedFor,
    isUnlimited,
    maxUses,
    price,
  } = addonDetails;

  if (!canView) return null;

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Add Ons Details")} />
        <div className="common_card">
          <DetailsShimmer />
        </div>
      </div>
    );
  }

  return (
    <div className="page-content common_details_page">
      <DetailsTitle title={t("Add Ons Details")} />
      <div className="common_card">
        <Row>
          <Col>
            <h6 className="label">{t("Add On Name")}</h6>
            <h6 className="title">{title?.en}</h6>
          </Col>
          <Col>
            <h6 className="label">{t("Allowed For")}</h6>
            <h6 className="value">
              {allowedFor
                ?.map(
                  (item) => PLAN_OPTIONS.find((opt) => opt.value === item)?.name
                )
                .filter(Boolean)
                .join(", ")}
            </h6>
          </Col>
          <Col>
            <h6 className="label">{t("Price")}</h6>
            <h6 className="value">
              <DisplayPrice value={price} width="12" height="15" />
            </h6>
          </Col>
          <Col>
            <h6 className="label">{t("Status")}</h6>
            <StatusBadge status={status} t={t} />
          </Col>
          <Col>
            <h6 className="label">{t("Unlimited")}</h6>
            <h6 className="value">{isUnlimited ? t("Yes") : t("No")}</h6>
          </Col>
          {!isUnlimited && (
            <Col>
              <h6 className="label">{t("Max Usage")}</h6>
              <h6 className="value">{maxUses}</h6>
            </Col>
          )}
        </Row>

        <Row className="mt-4">
          <Col lg={12}>
            <h6 className="label">{t("Description")}</h6>
            <h6 className="value">{description?.en || "-"}</h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddonDetails;
